module.exports = __webpack_public_path__ + "assets/img/403527476deacf57c09ba0b4a112d038.svg";